/**
 * Reset Overlay Utility
 * Provides a shared loading overlay for reset operations
 */

class ResetOverlay {
  private static overlayId = 'resetLoadingOverlay';
  private static animationId = 'resetSpinAnimation';

  /**
   * Show the reset loading overlay
   */
  static show(): void {
    // Remove any existing overlay first
    this.hide();

    const overlay = document.createElement('div');
    overlay.id = this.overlayId;
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: white;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: inherit;
    `;
    overlay.innerHTML = `
      <div style="text-align: center;">
        <div style="font-size: 18px; font-weight: 600; color: var(--colors-brand-navy); margin-bottom: 16px;">
          Resetting...
        </div>
        <div style="
          width: 40px;
          height: 40px;
          border: 4px solid var(--colors-brand-light-gray);
          border-top: 4px solid var(--colors-brand-blue);
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto;
        "></div>
      </div>
    `;
    
    // Add spin animation if not already present
    if (!document.getElementById(this.animationId)) {
      const style = document.createElement('style');
      style.id = this.animationId;
      style.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
    
    document.body.appendChild(overlay);
  }

  /**
   * Hide the reset loading overlay
   */
  static hide(): void {
    const overlay = document.getElementById(this.overlayId);
    if (overlay) {
      overlay.remove();
    }
  }
}

// Export for module usage
export default ResetOverlay;

// Make available globally for non-module scripts
declare global {
  interface Window {
    ResetOverlay: typeof ResetOverlay;
  }
}

if (typeof window !== 'undefined') {
  window.ResetOverlay = ResetOverlay;
}